import { createSelector } from 'reselect';
import routingSelector from './routingSelector';

export default createSelector(
    routingSelector,
    ({ locationBeforeTransitions: { query: { darkmode } } }) => darkmode === 'true'
);



// WEBPACK FOOTER //
// ./app/common/selectors/darkThemeSelector.js